import { Injectable } from '@angular/core';
import * as CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root'
})
export class ServicioAesService {

  private encPassword = '12345';
  private decPassword= '12345';

  constructor() { }

  public encrypt(data: string): string {
    return CryptoJS.AES.encrypt(data, this.encPassword.trim()).toString();
  }

  public decrypt(data: string): string {
    return CryptoJS.AES.decrypt(data.trim(), this.decPassword.trim()).toString(CryptoJS.enc.Utf8);
  }
}
